export default "__VITE_ASSET__CxHi9scf__"